import { DotIcon } from '@/components/icons/DotIcon';
import { isHexColor } from '@utils/checkHexCode';
import { Image } from '@design-system/Image';
import { getFoodImageUrl } from '@utils/nutrition/getImageUrl';

interface MyFoodsPageBasicDetailsProps {
  basicDetailsInfo: {
    color: string;
    image_url: string;
    name: string;
    rank: string;
    servings: string;
  };
}

export const MyFoodsPageBasicDetails = ({
  basicDetailsInfo,
}: MyFoodsPageBasicDetailsProps) => {
  const { color, image_url, name, rank, servings } = basicDetailsInfo;

  const rankColor = isHexColor(color) ? { color } : undefined;

  return (
    <div className="flex flex-col md:flex-row items-center md:items-end lg:justify-between">
      <div className="flex flex-col justify-end items-center md:items-start">
        {name && (
          <div className="text-4xl font-normal font-sans min-w-64 max-w-80 flex justify-center md:justify-start">
            {name}
          </div>
        )}
        <div className="mt-4 flex flex-row min-w-64 max-w-80 justify-center md:justify-start">
          {rank && (
            <div className="flex items-center">
              <DotIcon
                width={24}
                height={24}
                className="!size-6"
                style={rankColor}
              />
              <p style={rankColor}>{rank}</p>
            </div>
          )}
          {servings && (
            <p className="typography-body ml-3 text-tertiary">{servings}</p>
          )}
        </div>
      </div>
      {image_url && (
        <Image
          src={getFoodImageUrl(image_url)}
          alt="food_image"
          className="mix-blend-multiply"
        />
      )}
    </div>
  );
};
